<template>
  <div class="charge-course-box show-flex-box-r" v-if="$store.state.chargeStatus">
    <div class="apply-charge-course show-flex-box-r show-flex-center" v-if="!chargeSuccess">
      <dl class="show-flex-box-c">
        <dt class="show-flex-box-r show-flex-center">
          <h1>您好，请填写以下信息注册账号并兑换课程</h1>
        </dt>
        <dd class="user-info show-flex-box-c">
          <ul class="show-flex-box-c">
            <li class="show-flex-box-r input-style-1">
              <span>您的姓名：</span>
              <input type="text" placeholder="请输入2-10个字符（必填）" maxlength="8">
            </li>
            <li class="show-flex-box-r input-style-2">
              <span>您的电话：</span>
              <div class="show-flex-box-r">
                <input type="text" placeholder="请输入您联系的电话（必填）" maxlength="11">
                <strong>获取验证码</strong>
                <!-- <strong>获取验证码</strong> -->
              </div>
            </li>
            <li class="show-flex-box-r input-style-1">
              <span>验 证 码 ：</span>
              <input type="text" placeholder="请输入您收到的验证码（必填）" maxlength="4">
            </li>
            <li class="show-flex-box-r input-style-1">
              <span>机构名称：</span>
              <input type="text" placeholder="请输入30个以内字符（必填）">
            </li>
            <li class="show-flex-box-r input-style-1">
              <span>机构地址：</span>
              <input class="choose-address" type="text" placeholder="请选择省/市/区/街道（必填）" readonly>
            </li>
          </ul>
        </dd>
        <dd class="next-step show-flex-box-r">
          <span class="show-flex-box-r" @click="tabToCloseTrial">
            <strong>取消</strong>
          </span>
          <strong class="show-flex-box-r" @click="tabToApply">
            <span>兑换课程</span>
          </strong>
        </dd>
      </dl>
    </div>
    <div class="apply-success show-flex-box-c show-flex-center" v-else>
      <h1>兑换成功！</h1>
      <span class="show-flex-box-r" @click="tabToCloseTrial">
        <strong>确认</strong>
      </span>
    </div>
  </div>
</template>

<script>
import regex from '@/filter/regex'

export default {
  name: 'charge_course_cpn',
  data () {
    return {
      chargeSuccess: false
    }
  },
  methods: {
    tabToCloseTrial: function() {
      $('body').css({"overflow":'auto'});
      this.$store.commit('SET_ISCHARGE',false);
      this.chargeSuccess = false;
    },
    tabToApply: function() {
      if (true) {
        this.chargeSuccess = true;
      }
    }
  }
}
</script>

<style lang="less" scoped>

  //公共字体样式  start
  .charge-course-font-style( @size; @weight; @height; @color ) {
    display: block;
    font-size: @size;
    font-weight: @weight;
    line-height: @height;
    color: @color;
    white-space: nowrap;
  }

  .charge-course-box{
    position: fixed;
    // top: 0;
    // left: 0;
    // right: 0;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    z-index: 999;
    &>.apply-charge-course{
      // position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 480px;
      height: 525px;
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
      &>dl{
        width: 100%;
        height: 100%;
        &>dt{
          width: 100%;
          height: 73px;
          border-bottom: 1px solid rgba(229, 229, 229, 1);
          &>h1{
            .charge-course-font-style( 18px; bold; normal; rgba(25, 29, 33, 1) );
          }
        }
        &>.user-info{
          width: 100%;
          &>ul{
            padding: 25px 47px 0px 42px;
            justify-content: center;
            align-items: center;
            &>li{
              margin-bottom: 28px;
              &>::-webkit-input-placeholder{
                font-size: 14px;
                color: rgba(128, 128, 128, 1);
              }
            }
            &>.input-style-1{
              width: 100%;
              height: 42px;
              justify-content: space-between;
              align-items: center;
              &>span{
                width: 0;
                flex-grow: 1;
                padding-right: 14px;
                .charge-course-font-style( 18px; 500; normal; rgba(25, 29, 33, 1) );
                text-align: justify;
              }
              &>input{
                width: 268px;
                padding: 13px 16px 13px 16px;
                border-radius: 6px;
                border: 1px solid rgba(229, 229, 229, 1); 
                background: rgba(250, 250, 250, 1);
                .charge-course-font-style( 14px; 400; normal; rgba(25, 29, 33, 1) );
              }
              &>.choose-address{
                cursor: pointer;
              }
            }
            &>.input-style-2{
              width: 100%;
              height: 42px;
              justify-content: space-between;
              align-items: center;
              &>span{
                width: 0;
                flex-grow: 1;
                padding-right: 14px;
                .charge-course-font-style( 18px; 500; normal; rgba(25, 29, 33, 1) );
                text-align: justify;
              }
              &>div{
                width: 300px;
                border-radius: 6px;
                border: 1px solid rgba(229, 229, 229, 1); 
                background: rgba(250, 250, 250, 1);
                align-items: center;
                justify-content: space-between;
                &>input{
                  width: 172px;
                  padding: 13px 16px 13px 16px;
                  border: none;
                  background: none;
                  .charge-course-font-style( 14px; 400; normal; rgba(25, 29, 33, 1) );
                }
                &>strong{
                  width: 0;
                  height: 25px;
                  flex-grow: 1;
                  border-left: 1px solid rgba(229, 229, 229, 1);
                  .charge-course-font-style( 14px; 400; 25px; rgba(128, 128, 128, 1) );
                  padding-left: 10px;
                  cursor: pointer;
                }
              }
            }
          }
        }
        &>.next-step{
          // padding-top: 40px;
          padding-left: 44px;
          padding-right: 47px;
          // padding-bottom: 44px;
          justify-content: space-between;
          align-items: center;
          &>span{
            justify-content: center;
            align-items: center;
            width: 180px;
            height: 40px;
            border-radius: 5px;
            background: rgba(220, 220, 220, 1);
            cursor: pointer;
            &>strong{
              .charge-course-font-style( 17px; 500; 40px; rgba(254, 254, 254, 1) );
            }
          }
          &>strong{
            justify-content: center;
            align-items: center;
            width: 180px;
            height: 40px;
            border-radius: 5px;
            background: rgba(255, 120, 0, 1);
            cursor: pointer;
            &>span{
              .charge-course-font-style( 17px; 500; 40px; rgba(254, 254, 254, 1) );
            }
          }
        }
      }
    }
    &>.apply-success{
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 480px;
      height: 200px;
      background: #fff;
      border-radius: 10px;
      overflow: hidden;
      &>h1{
        .charge-course-font-style( 20px; 500; 25px; rgba(255, 120, 0, 1) );
        padding-bottom: 5px;
      }
      &>span{
        width: 180px;
        height: 40px;
        border-radius: 5px;
        background: #ff7800;
        justify-content: center;
        align-items: center;
        margin-top: 25px;
        cursor: pointer;
        &>strong{
          .charge-course-font-style( 20px; 500; 40px; rgba(255, 255, 255, 1) );
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/charge_course_cpn.vue